import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("zelle",i`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_6234_20223)">
                <mask
                    id="mask0_6234_20223"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24">
                    <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6234_20223)">
                    <path
                        d="M19.3333 24H4.66667C2.08933 24 0 21.9107 0 19.3333V4.66667C0 2.08933 2.08933 0 4.66667 0H19.3333C21.9107 0 24 2.08933 24 4.66667V19.3333C24 21.9107 21.9107 24 19.3333 24Z"
                        fill="#AA00FF" />
                    <path
                        d="M7.66667 8.33301H17C17.368 8.33301 17.6667 8.03434 17.6667 7.66634V5.99967C17.6667 5.63167 17.368 5.33301 17 5.33301H7.66667C7.29867 5.33301 7 5.63167 7 5.99967V7.66634C7 8.03434 7.29867 8.33301 7.66667 8.33301Z"
                        fill="white" />
                    <path
                        d="M7.33317 19H16.9998C17.3678 19 17.6665 18.7013 17.6665 18.3333V16.6667C17.6665 16.2987 17.3678 16 16.9998 16H7.33317C6.96517 16 6.6665 16.2987 6.6665 16.6667V18.3333C6.6665 18.7013 6.96517 19 7.33317 19Z"
                        fill="white" />
                    <path
                        d="M10.8335 3.33333V7.33333C10.8335 7.51733 10.9828 7.66667 11.1668 7.66667H13.5002C13.6842 7.66667 13.8335 7.51733 13.8335 7.33333V3.33333C13.8335 3.14933 13.6842 3 13.5002 3H11.1668C10.9828 3 10.8335 3.14933 10.8335 3.33333Z"
                        fill="white" />
                    <path
                        d="M10.8335 17.3333V21.3333C10.8335 21.5173 10.9828 21.6667 11.1668 21.6667H13.5002C13.6842 21.6667 13.8335 21.5173 13.8335 21.3333V17.3333C13.8335 17.1493 13.6842 17 13.5002 17H11.1668C10.9828 17 10.8335 17.1493 10.8335 17.3333Z"
                        fill="white" />
                    <path
                        d="M7.05187 16.6256H10.6665L17.5292 8.06624C17.6479 7.91824 17.5419 7.69824 17.3519 7.69824H13.6665L6.84987 16.1989C6.70987 16.3689 6.8312 16.6256 7.05187 16.6256Z"
                        fill="white" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6234_20223">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Zelle};
